import { useState, useEffect } from "react";
import throttle from "lodash/throttle";
import { BREAKPOINTS_PX } from "../shared/general";
import { window, exists } from "browser-monads";

// Store sorted breakpoints as a nested array of key value pairs e.g. [['mobile', 600], ...]
const sortedBreakpoints = Object.entries(BREAKPOINTS_PX).sort(
  ([, a], [, b]) => a - b
);

/**
 * Returns the next breakpoint up from the current window width,
 * returns undefined if window width is larger than the largest breakpoint
 */
const getCurrentBreakpoint = () => {
  if (!exists(window)) {
    return undefined;
  }

  const width = window.innerWidth;

  const currentBreakpoint = sortedBreakpoints.find(
    ([, breakpoint]) => width < breakpoint
  );

  return currentBreakpoint ? currentBreakpoint[0] : undefined;
};

const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(() => getCurrentBreakpoint());

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getCurrentBreakpoint());
    };

    const handleResizeThrottled = throttle(handleResize, 500);

    window.addEventListener("resize", handleResizeThrottled);

    return () => {
      window.removeEventListener("resize", handleResizeThrottled);
      handleResizeThrottled.cancel();
    };
  }, [setBreakpoint]);

  return breakpoint;
};

export default useBreakpoint;
